import { CodetableHeadingHeadingProps } from 'app/area/codetable/list/list-items/types';
import React, { Component } from 'react';
import styles from './codetable-heading.scss';

export class CodetableHeading extends Component<CodetableHeadingHeadingProps> {

  public render() {

    return <div className={styles.headingContainer}>
      <div className={styles.defaultColumn}>
        {this.props.codetableName}
      </div>
      <div className={`${styles.sequenceColumn} ${this.props.isHierarchy ? styles.hierarchy : styles.flatList}`}>
        {this.props.sequenceName}
      </div>
      <div className={`${styles.fixedColumn} ${this.props.isHierarchy ? styles.hierarchy : styles.flatList}`} />
    </div>;
  }
}
